import style from './ButtonTextSimple.module.css'

interface IButtonTextSimple {
    text: string;
    onClick: () => void;
}

export const ButtonTextSimple: React.FC<IButtonTextSimple> = (data) => {

    return (
        // aqui dentro vamos colocar nosso JSX     
        <button onClick={data.onClick} className={style.Content} >
            <span>{data.text}</span>
        </button>
    )
}
